import GreenMarker from "@assets/images/TasksMap/delivered.png";
import BlueMarker from "@assets/images/TasksMap/pending.png";
import YellowMarker from "@assets/images/TasksMap/reschedule.png";
import RedMarker from "@assets/images/TasksMap/rto.png";

export const COLOR_CODE = {
  all: {
    border: "rgba(0,0,0,0.6)",
    text: "rgba(0,0,0,1)",
  },
  pending: {
    border: "rgba(15, 100, 166, 0.6)",
    text: "rgba(15, 100, 166, 1)",
  },
  rescheduled: {
    border: "rgba(225, 175, 0, 0.6)",
    text: "rgba(225, 175, 0, 1)",
  },
  rto: {
    border: "rgba(255, 46, 0, 0.6)",
    text: "rgba(255, 46, 0, 1)",
  },
  delivered: {
    border: "rgba(0, 171, 89, 0.6)",
    text: "rgba(0, 171, 89, 1)",
  },
};

export const markerSourceMap: { [key: string]: any } = {
  pending: BlueMarker,
  delivered: GreenMarker,
  rto: RedMarker,
  rescheduled: YellowMarker,
};

export const STORAGE_KEY = "MAP_ACTION";

export const contactAllowedCardTypes = [
  "DELIVERED",
  "RTO_CAN_CANCEL",
  "RTO_CANNOT_CANCEL",
];
